// Module
var code = "<img *ngIf=\"src\" [src]=\"src\" [ngClass]=\"imgClass || name\" [alt]=\"alt || name\"/>";
// Exports
module.exports = code;